export const appTitle = 'Film Festival';
export const API_KEY = '7b448dca9bed629e504ae4372fb2e110';